/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { padding } from 'polished';

import t from 'app/utils/translate';
import { resetPerformanceDiff } from 'app/actions/challengeActions';
import RowHeader from '../commons/RowHeader';
import MultiSwitch from '../commons/MultiSwitch';
import ResetButton from '../commons/ResetButton';

type Props = {
  diffValue?: boolean,
  displayOpponent?: boolean,
  displayUser?: boolean,
  onComparisonReset: () => void,
  onDisplayChange: () => void,
  onResetPerformanceDiff: () => void,
  showCloseButton?: boolean
};

const Inner = styled.div({
  alignItems: 'center',
  display: 'flex',
  flexBasis: '100%',
  position: 'relative',
  justifyContent: 'space-between',
  height: '100%'
});

const Final = styled.div({
  height: '100%'
});

const Title = styled.div(({ theme }) => ({
  fontSize: theme.fontSize.small,
  margin: 'auto'
}));

const StyledResetButton = styled(ResetButton)(({ theme }) => ({
  height: '100%',
  ...padding(0, theme.spacing.small),
  marginRight: -theme.spacing.small
}));

class TeamPerformanceHead extends React.PureComponent<Props> {
  props: Props;

  static defaultProps = {
    diffValue: false,
    displayOpponent: false,
    displayUser: false,
    showCloseButton: false
  };

  componentWillUnmount() {
    const { onResetPerformanceDiff } = this.props;
    onResetPerformanceDiff();
  }

  render() {
    const {
      diffValue,
      displayOpponent,
      displayUser,
      onComparisonReset,
      onDisplayChange,
      showCloseButton
    } = this.props;

    const displayBoth = displayOpponent && displayUser;
    const titleText =
      (displayBoth && 'Lineup Comparison') ||
      (displayUser && 'Your Lineup Performance') ||
      'Entrant Lineup Performance';

    return (
      <RowHeader first>
        <Inner>
          {displayBoth && (
            <MultiSwitch
              onSelect={onDisplayChange}
              options={[
                {
                  label: t('All'),
                  value: false
                },
                {
                  label: t('Diff'),
                  value: true
                }
              ]}
              value={diffValue}
            />
          )}
          <Title>{titleText}</Title>
          <Final>
            {showCloseButton && <StyledResetButton label="" onClick={onComparisonReset} />}
          </Final>
        </Inner>
      </RowHeader>
    );
  }
}

const actions = {
  onResetPerformanceDiff: resetPerformanceDiff
};

export default connect(null, actions)(TeamPerformanceHead);
